var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJiehedian(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 4785"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 675",
    d: "M3.46875 2.6875H14.0938",
    stroke: "#2F88FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 676",
    d: "M8.65625 8.125L14.0937 8.125",
    stroke: "#2F88FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 677",
    d: "M14.0938 13.3125L10.6563 13.3125C9.55168 13.3125 8.65625 12.4171 8.65625 11.3125L8.65625 2.75",
    stroke: "#2F88FF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 93",
    cx: 3.34375,
    cy: 2.625,
    r: 1.625,
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 96",
    cx: 14.1562,
    cy: 2.625,
    r: 1.625,
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 94",
    cx: 14.1562,
    cy: 8,
    r: 1.625,
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 95",
    cx: 14.1562,
    cy: 13.375,
    r: 1.625,
    fill: "white",
    stroke: "black"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJiehedian);
export default __webpack_public_path__ + "static/media/jiehedian.52686a757bc3c805c06f2047d5acad04.svg";
export { ForwardRef as ReactComponent };